import { toast } from 'react-toastify';

import { IS_IN_APP_BROWSER, IS_IOS } from '@/constants/enviroment';
import { setShipmentPayment } from '@/routes/order';
import { IOrder } from '@/store/ducks/order/types';

export type ButtonType = 'Redirect' | 'Default' | 'link';

export const openPaymentPage = (paymentUrl: string) => {
  if (IS_IN_APP_BROWSER && IS_IOS) {
    const noOpenerLink = document.createElement('a');
    noOpenerLink.href = paymentUrl;
    noOpenerLink.target = '_blank';
    noOpenerLink.rel = 'noopener noreferrer';
    document.body.appendChild(noOpenerLink);
    noOpenerLink.click();
    document.body.removeChild(noOpenerLink);

    setTimeout(() => {
      window.location.href = paymentUrl;
    }, 1000);

    return;
  }

  const paymentWindow = window.open(paymentUrl, '_blank');

  if (paymentWindow) paymentWindow.opener = null;
};

export const isPaymentMethodSelected = (
  order: IOrder,
  paymentId: number,
  planId: number,
  callBack?: (payment: number) => void,
) => {
  setShipmentPayment(order.id, paymentId, planId)
    .then(() => {
      const payment = order.payments?.find(
        (p) => p.integration_id === paymentId && p.payment_plan_id === planId,
      );
      if (callBack) {
        callBack(payment?.id || 0);
      }
    })
    .catch((e) => {
      console.error(e);

      const isCredentialsMessage = e?.response?.data?.message?.includes('credencia');
      const fallbackMessage = 'Ocorreu um erro ao adicionar o método de pagamento';
      const message = isCredentialsMessage
        ? fallbackMessage
        : e?.response?.data?.message ?? fallbackMessage;

      toast(message, { type: 'error' });
    });
};

export const buttonColorByType: Record<ButtonType, string> = {
  Redirect: '#1826EC',
  Default: '',
  link: '',
};

export const btnTitle: Record<ButtonType, string> = {
  Redirect: 'Gerar pagamento',
  Default: 'Adicionar pagamento',
  link: 'Pagar',
};
